import { useEffect, useState } from "react";

export function useData<T>(props: {
 default: T;
 path: string;
 init?: RequestInit;
 map?(result: unknown): unknown;
}) {
 const [data, setData] = useState<T>(props.default);
 useEffect(() => {
  fetch(props.path, props.init)
   .then((t) => t.json())
   .then((resp: unknown) => {
    if (props.map) {
     resp = props.map(resp);
    }
    setData(resp as T);
   });
 }, []);
 return { data };
}
